class DatePickerModal {

  constructor() {
    console.log(this);
  }

  static initFlatpickr(instance, eventTarget) {
    flatpickr(instance, {
      minDate: "1900-01-01",  // Minimum date in ISO8601 format
      maxDate: "2050-12-31",  // Maximum date in ISO8601 format
      // dateFormat: "D, M j, Y", // Custom format (e.g., Mon, Aug 17, 2023)
      dateFormat: "d-n-Y",     // Custom format (e.g., 17-08-2023)
      // defaultDate: "today",   // Default to today's date
      altInput: true,         // Adds a readable input field for users
      altFormat: "F j, Y",    // Alternative input format (e.g., August 17, 2023)
      disableMobile: false,   // Show on mobile devices
      onChange: function(selectedDates, dateStr, instance) {
        let input = this.input;
        let displayInput = input.nextElementSibling;
        let index = input.closest('.calendar-container').dataset.index;
        displayInput.style.width = `${(displayInput.value.length + 0.5 ) / 2}em`
        let customEvent = new CustomEvent(`dateSelected-${eventTarget}`, {
          detail: {
            date: dateStr,
            index: index,
          }
        });

        document.dispatchEvent(customEvent);
      }
    });
  }
}

const datePickerModal = new DatePickerModal();